module.exports = __webpack_public_path__ + "static/media/career-profile2.1fead2be.png";